import type { FC, ReactNode, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';
import type { CompatibleCellChange, CompatibleChangeSource } from '@/components/UI/SpreadSheet/Spreadsheet';

import Spreadsheet, { type SpreadsheetSettings } from '@/components/UI/SpreadSheet/Spreadsheet';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import { defaultMetadataToColumnSettingMapper } from '@/support/hot';
interface AnimalsTableProps {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetSettings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  patchMetadataAfterSettingsUpdated: () => void;
  maxRows: number;
  afterChange?: (changes: Array<CompatibleCellChange> | null, source: CompatibleChangeSource) => void;
  afterCreateRow?: (index: number, amount: number, source?: CompatibleChangeSource) => void;
  afterRemoveRow?: (source: CompatibleChangeSource | undefined) => void;
  afterValidation?: (
    isValid: boolean,
    value: ReactNode,
    row: number,
    prop: string | number,
    source: CompatibleChangeSource
  ) => void;
  setInvalid?: (invalid: boolean) => void;
  modalView?: boolean;
}

const AnimalsTable: FC<AnimalsTableProps> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  patchMetadataAfterSettingsUpdated,
  maxRows,
  afterChange,
  afterCreateRow,
  afterRemoveRow,
  afterValidation,
  setInvalid,
  modalView = false,
}) => {
  return (
    <Spreadsheet
      className="mt3"
      testPrefix="study-create-animals"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapper}
      patchMetadataAfterSettingsUpdated={patchMetadataAfterSettingsUpdated}
      maxRows={maxRows}
      addCol
      afterChange={afterChange}
      afterCreateRow={afterCreateRow}
      afterRemoveRow={afterRemoveRow}
      afterValidation={afterValidation}
      setInvalid={setInvalid}
      modalView={modalView}
    />
  );
};

export default AnimalsTable;
